export const STANDARD_ERC20_DECIMALS = 18
